import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, ProtectedRoute } from './lib/auth'
import Layout from './components/Layout'
import DashboardPage from './pages/DashboardPage'
import OKRsPage from './pages/OKRsPage'
import PipelinePage from './pages/PipelinePage'
import ClientsPage from './pages/ClientsPage'
import CompliancePage from './pages/CompliancePage'
import TeamPage from './pages/TeamPage'
import LoginPage from './pages/LoginPage'

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="okrs" element={<OKRsPage />} />
            <Route path="pipeline" element={<PipelinePage />} />
            <Route path="clients" element={<ClientsPage />} />
            <Route path="compliance" element={<CompliancePage />} />
            <Route path="team" element={<TeamPage />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  )
}

export default App
